import HomeIcon from "@mui/icons-material/Home";
import ServicesIcon from "@mui/icons-material/Settings";
import PortfolioIcon from "@mui/icons-material/Work";
import ReviewsIcon from "@mui/icons-material/Star";

const Links = [
  {
    url: "#details",
    text: "Details",
    icon: <HomeIcon />,
  },
  {
    url: "#services",
    text: "Services",
    icon: <ServicesIcon />,
  },
  {
    url: "#portfolio",
    text: "Portfolio",
    icon: <PortfolioIcon />,
  },
  {
    url: "#reviews",
    text: "Reviews",
    icon: <ReviewsIcon />,
  },
];

export default Links;
